import md5 from './md5'

/**
 *  小牛翻译相关工具
 */
export default class Translate2xn {
  static appId = '9Tg1693876982190';
  static apikey = '021ed9385ce19118fe96bb936b36b9c8';
  /**
   * 语种下拉列表
   */
  static langCodeArr = [
    {
      value: 'zh',
      label: '中文(简体)'
    },
    {
      value: 'en',
      label: '英语'
    },
    {
      value: 'ja',
      label: '日语'
    },
    {
      value: 'ko',
      label: '韩语'
    },
    {
      value: 'ru',
      label: '俄语'
    },
    {
      value: 'fr',
      label: '法语'
    },
    {
      value: 'de',
      label: '德语'
    },
    {
      value: 'ar',
      label: '阿拉伯语'
    },
    {
      value: 'it',
      label: '意大利语'
    },
    {
      value: 'pt',
      label: '葡萄牙语'
    },
    {
      value: 'el',
      label: '希腊语'
    },
    {
      value: 'cs',
      label: '捷克语'
    },
    {
      value: 'pl',
      label: '波兰语'
    },
    {
      value: 'nl',
      label: '荷兰语'
    },
    {
      value: 'ro',
      label: '罗马尼亚语'
    },
    {
      value: 'sv',
      label: '瑞典语'
    },
    {
      value: 'da',
      label: '丹麦语'
    },
    {
      value: 'vi',
      label: '越南语'
    },
    {
      value: 'th',
      label: '泰语'
    },
    {
      value: 'fil',
      label: '菲律宾语'
    },
    {
      value: 'bg',
      label: '保加利亚语'
    },
    {
      value: 'es',
      label: '西班牙语'
    },
    {
      value: 'ms',
      label: '马来语'
    },
    {
      value: 'id',
      label: '印尼语'
    },
    {
      value: 'km',
      label: '高棉语'
    },
    {
      value: 'lo',
      label: '老挝语'
    },
    {
      value: 'my',
      label: '缅甸语'
    },
    {
      value: 'ps',
      label: '普什图语'
    },
    {
      value: 'hi',
      label: '印地语'
    },
    {
      value: 'kk',
      label: '哈萨克语(西里尔)'
    },
    {
      value: 'ka',
      label: '哈萨克语'
    },
    {
      value: 'tr',
      label: '土耳其语'
    },
    {
      value: 'fa',
      label: '波斯语'
    },
    {
      value: 'chb',
      label: '中文(繁体)'
    },
    {
      value: 'sq',
      label: '阿尔巴尼亚语'
    },
    {
      value: 'am',
      label: '阿姆哈拉语'
    },
    {
      value: 'az',
      label: '阿塞拜疆语'
    },
    {
      value: 'ee',
      label: '埃维语'
    },
    {
      value: 'ga',
      label: '爱尔兰语'
    },
    {
      value: 'et',
      label: '爱沙尼亚语'
    },
    {
      value: 'om',
      label: '奥罗莫语'
    },
    {
      value: 'os',
      label: '奥赛梯语'
    },
    {
      value: 'tpi',
      label: '巴布亚皮坎语'
    },
    {
      value: 'ba',
      label: '巴什基尔语'
    },
    {
      value: 'eu',
      label: '巴斯克语'
    },
    {
      value: 'be',
      label: '白俄罗斯语'
    },
    {
      value: 'mww',
      label: '白苗文'
    },
    {
      value: 'bi',
      label: '比斯拉马语'
    },
    {
      value: 'bem',
      label: '别姆巴语'
    },
    {
      value: 'is',
      label: '冰岛语'
    },
    {
      value: 'bs',
      label: '波斯尼亚语'
    },
    {
      value: 'tn',
      label: '茨瓦纳语'
    },
    {
      value: 'ts',
      label: '聪加语'
    },
    {
      value: 'tt',
      label: '鞑靼语'
    },
    {
      value: 'fj',
      label: '斐济语'
    },
    {
      value: 'fi',
      label: '芬兰语'
    },
    {
      value: 'fy',
      label: '弗里西语'
    },
    {
      value: 'kg',
      label: '刚果语'
    },
    {
      value: 'jy',
      label: '格鲁吉亚语'
    },
    {
      value: 'gu',
      label: '古吉拉特语'
    },
    {
      value: 'ht',
      label: '海地克里奥尔语'
    },
    {
      value: 'ha',
      label: '豪萨语'
    },
    {
      value: 'ky',
      label: '吉尔吉斯语'
    },
    {
      value: 'gl',
      label: '加利西亚语'
    },
    {
      value: 'ca',
      label: '加泰罗尼亚语'
    },
    {
      value: 'kn',
      label: '卡纳达语'
    },
    {
      value: 'kek',
      label: '凯克其语'
    },
    {
      value: 'co',
      label: '科西嘉语'
    },
    {
      value: 'otq',
      label: '克雷塔罗奥托米语'
    },
    {
      value: 'hr',
      label: '克罗地亚语'
    },
    {
      value: 'ku',
      label: '库尔德语'
    },
    {
      value: 'la',
      label: '拉丁语'
    },
    {
      value: 'lv',
      label: '拉脱维亚语'
    },
    {
      value: 'lt',
      label: '立陶宛语'
    },
    {
      value: 'ln',
      label: '林加拉语'
    },
    {
      value: 'rn',
      label: '隆迪语'
    },
    {
      value: 'lg',
      label: '卢干达语'
    },
    {
      value: 'lb',
      label: '卢森堡语'
    },
    {
      value: 'rw',
      label: '卢旺达语'
    },

    {
      value: 'mg',
      label: '马尔加什语'
    },
    {
      value: 'mt',
      label: '马耳他语'
    },
    {
      value: 'mr',
      label: '马拉地语'
    },
    {
      value: 'ml',
      label: '马拉雅拉姆语'
    },
    {
      value: 'mhr',
      label: '马里语'
    },
    {
      value: 'mk',
      label: '马其顿语'
    },
    {
      value: 'mi',
      label: '毛利语'
    },
    {
      value: 'bn',
      label: '孟加拉语'
    },
    {
      value: 'af',
      label: '南非荷兰语'
    },
    {
      value: 'xh',
      label: '南非科萨语'
    },
    {
      value: 'zu',
      label: '南非祖鲁语'
    },
    {
      value: 'ne',
      label: '尼泊尔语'
    },
    {
      value: 'no',
      label: '挪威语'
    },
    {
      value: 'pap',
      label: '帕皮阿门托语'
    },
    {
      value: 'pa',
      label: '旁遮普语'
    },
    {
      value: 'ny',
      label: '齐切瓦语'
    },
    {
      value: 'tw',
      label: '契维语'
    },
    {
      value: 'sm',
      label: '萨摩亚语'
    },
    {
      value: 'sr',
      label: '塞尔维亚语'
    },
    {
      value: 'crs',
      label: '塞舌尔克里奥尔语'
    },
    {
      value: 'st',
      label: '塞索托语'
    },
    {
      value: 'sg',
      label: '桑戈语'
    },
    {
      value: 'si',
      label: '僧伽罗语'
    },
    {
      value: 'mrj',
      label: '山地马里语'
    },
    {
      value: 'eo',
      label: '世界语'
    },
    {
      value: 'sk',
      label: '斯洛伐克语'
    },
    {
      value: 'sl',
      label: '斯洛文尼亚语'
    },
    {
      value: 'sw',
      label: '斯瓦希里语'
    },
    {
      value: 'gd',
      label: '苏格兰盖尔语'
    },
    {
      value: 'so',
      label: '索马里语'
    },
    {
      value: 'tg',
      label: '塔吉克语'
    },
    {
      value: 'ty',
      label: '塔希提语'
    },
    {
      value: 'te',
      label: '泰卢固语'
    },
    {
      value: 'ta',
      label: '泰米尔语'
    },
    {
      value: 'to',
      label: '汤加语'
    },
    {
      value: 'tig',
      label: '提格雷语'
    },
    {
      value: 'tk',
      label: '土库曼语'
    },
    {
      value: 'war',
      label: '瓦瑞语'
    },
    {
      value: 'cy',
      label: '威尔士语'
    },
    {
      value: 'udm',
      label: '乌德穆尔特语'
    },
    {
      value: 'ur',
      label: '乌尔都语'
    },
    {
      value: 'uk',
      label: '乌克兰语'
    },
    {
      value: 'uz',
      label: '乌兹别克语'
    },
    {
      value: 'he',
      label: '希伯来语'
    },
    {
      value: 'haw',
      label: '夏威夷语'
    },
    {
      value: 'sd',
      label: '信德语'
    },
    {
      value: 'hu',
      label: '匈牙利语'
    },
    {
      value: 'sn',
      label: '修纳语'
    },
    {
      value: 'ceb',
      label: '宿务语'
    },
    {
      value: 'hy',
      label: '亚美尼亚语'
    },
    {
      value: 'ig',
      label: '伊博语'
    },
    {
      value: 'yi',
      label: '意第绪语'
    },
    {
      value: 'su',
      label: '印尼巽他语'
    },
    {
      value: 'jv',
      label: '印尼爪哇语'
    },
    {
      value: 'yua',
      label: '尤卡坦玛雅语'
    },
    {
      value: 'yo',
      label: '约鲁巴语'
    },
    {
      value: 'yue',
      label: '粤语'
    },
    {
      value: 've',
      label: '文达语'
    },
    {
      value: 'acu',
      label: '阿丘雅语'
    },
    {
      value: 'agr',
      label: '阿瓜鲁纳语'
    },
    {
      value: 'ake',
      label: '阿卡瓦伊语'
    },
    {
      value: 'amu',
      label: '阿穆斯戈语'
    },
    {
      value: 'djk',
      label: '恩都卡语'
    },
    {
      value: 'bsn',
      label: '巴拉萨纳语'
    },
    {
      value: 'cjp',
      label: '卡韦卡尔语'
    },
    {
      value: 'cak',
      label: '卡克奇克尔语'
    },
    {
      value: 'cni',
      label: '坎帕语'
    },
    {
      value: 'kbh',
      label: '科奇语'
    },
    {
      value: 'cha',
      label: '查莫罗语'
    },
    {
      value: 'chr',
      label: '切诺基语'
    },
    {
      value: 'chq',
      label: '奇南特克语'
    },
    {
      value: 'cop',
      label: '科普特语'
    },
    {
      value: 'dik',
      label: '丁卡语'
    },
    {
      value: 'gbi',
      label: '加莱拉语'
    },
    {
      value: 'jac',
      label: '雅加达语'
    },
    {
      value: 'quc',
      label: '基切语'
    },
    {
      value: 'kab',
      label: '卡拜尔语'
    },
    {
      value: 'dop',
      label: '卢克帕语'
    },
    {
      value: 'mam',
      label: '马姆语'
    },
    {
      value: 'gv',
      label: '马恩岛语'
    },
    {
      value: 'nhg',
      label: '纳瓦特尔语'
    },
    {
      value: 'ojb',
      label: '奥吉布瓦语'
    },
    {
      value: 'pck',
      label: '派特语'
    },
    {
      value: 'pot',
      label: '波塔瓦托米语'
    },
    {
      value: 'quw',
      label: '盖丘亚语'
    },
    {
      value: 'rmn',
      label: '罗姆语'
    },
    {
      value: 'jiv',
      label: '舒阿尔语'
    },
    {
      value: 'syc',
      label: '叙利亚语'
    },
    {
      value: 'ber',
      label: '柏柏尔语'
    },
    {
      value: 'shi',
      label: '希尔哈语'
    },
    {
      value: 'tmh',
      label: '图阿雷格语'
    },
    {
      value: 'ppk',
      label: '乌玛语'
    },
    {
      value: 'usp',
      label: '乌斯潘坦语'
    },
    {
      value: 'wal',
      label: '瓦拉莫语'
    },
    {
      value: 'wol',
      label: '沃洛夫语'
    },
    {
      value: 'dje',
      label: '哲尔马语'
    },
    {
      value: 'or',
      label: '奥利亚语'
    },
    {
      value: 'ace',
      label: '亚齐语'
    },
    {
      value: 'fo',
      label: '法罗语'
    },
    {
      value: 'tet',
      label: '德顿语'
    },
    {
      value: 'br',
      label: '布列塔尼语'
    },
    {
      value: 'cv',
      label: '楚瓦什语'
    },
    {
      value: 'dv',
      label: '迪维希语'
    },
    {
      value: 'me',
      label: '黑山语'
    },
    {
      value: 'dz',
      label: '宗喀语'
    },
    {
      value: 'dyu',
      label: '迪尤拉语'
    },
    {
      value: 'kmr',
      label: '北库尔德语'
    },
    {
      value: 'mni',
      label: '曼尼普尔语'
    },
    {
      value: 'wlx',
      label: '瓦利语'
    },
    {
      value: 'azb',
      label: '南阿塞拜疆语'
    },
    {
      value: 'ikk',
      label: '伊卡语'
    },
    {
      value: 'qxr',
      label: '卡纳尔高地-基丘亚语'
    },
    {
      value: 'poh',
      label: '波孔奇语'
    },
    {
      value: 'ksd',
      label: '库阿努阿语'
    },
    {
      value: 'ifa',
      label: '中部伊富高语'
    },
    {
      value: 'meu',
      label: '摩图语'
    },
    {
      value: 'quz',
      label: '库斯科克丘亚语'
    },
    {
      value: 'mah',
      label: '马绍尔语'
    },
    {
      value: 'czt',
      label: '佐通钦语'
    },
    {
      value: 'prk',
      label: '佤语'
    },
    {
      value: 'ifb',
      label: '阿雅安伊富高语'
    },
    {
      value: 'bam',
      label: '班巴拉语'
    },
    {
      value: 'map',
      label: '北部马姆语'
    },
    {
      value: 'quh',
      label: '南玻利维亚克丘亚语'
    },
    {
      value: 'hwc',
      label: '夏威夷克里奥尔英语'
    },
    {
      value: 'cnh',
      label: '哈卡钦语'
    },
    {
      value: 'ngl',
      label: '隆韦语'
    },
    {
      value: 'gil',
      label: '基里巴斯语'
    },
    {
      value: 'hmo',
      label: '希里莫图语'
    },
    {
      value: 'tpm',
      label: '坦普尔马语'
    },
    {
      value: 'enx',
      label: '恩舍特语'
    },
    {
      value: 'mrw',
      label: '马拉瑙语'
    },
    {
      value: 'ctd',
      label: '特丁钦语'
    },
    {
      value: 'aym',
      label: '艾马拉语'
    },
    {
      value: 'knj',
      label: '阿卡特克语'
    },
    {
      value: 'tbz',
      label: '迪塔马利语'
    },
    {
      value: 'kac',
      label: '景颇语'
    },
    {
      value: 'mdy',
      label: '马勒语'
    },
    {
      value: 'lcp',
      label: '西部拉威语'
    },
    {
      value: 'sid',
      label: '锡达莫语'
    },
    {
      value: 'bba',
      label: '巴里巴语'
    },
    {
      value: 'izz',
      label: '伊兹语'
    },
    {
      value: 'rug',
      label: '罗维那语'
    },
    {
      value: 'mps',
      label: '达迪比语'
    },
    {
      value: 'lnd',
      label: '弄巴湾语'
    },
    {
      value: 'che',
      label: '车臣语'
    },
    {
      value: 'kpg',
      label: '卡平阿马朗伊语'
    },
    {
      value: 'mbb',
      label: '西布基农马诺布语'
    },
    {
      value: 'crh',
      label: '克里米亚鞑靼语'
    },
    {
      value: 'gub',
      label: '瓜哈哈拉语'
    },
    {
      value: 'tih',
      label: '蒂穆贡-穆鲁特语'
    },
    {
      value: 'lsi',
      label: '勒期语'
    },
    {
      value: 'hui',
      label: '胡里语'
    },
    {
      value: 'ify',
      label: '安蒂波洛伊富高语'
    },
    {
      value: 'dtp',
      label: '中部杜顺语'
    },
    {
      value: 'mad',
      label: '马都拉语'
    },
    {
      value: 'pil',
      label: '约姆语'
    },
    {
      value: 'tyv',
      label: '图瓦语'
    },
    {
      value: 'bus',
      label: '博科巴鲁语'
    },
    {
      value: 'bqp',
      label: '布萨语'
    },
    {
      value: 'acr',
      label: '阿奇语'
    },
    {
      value: 'mos',
      label: '莫西语'
    },
    {
      value: 'fuv',
      label: '尼日利亚富拉语'
    },
    {
      value: 'gof',
      label: '果发语'
    },
    {
      value: 'xsm',
      label: '格森语'
    },
    {
      value: 'duo',
      label: '东部卡加延-阿格塔语'
    },
    {
      value: 'shp',
      label: '西皮沃语'
    },
    {
      value: 'bnp',
      label: '波拉语'
    },
    {
      value: 'amk',
      label: '安拜语'
    },
    {
      value: 'jae',
      label: '雅比姆语'
    },
    {
      value: 'nop',
      label: '努曼干语'
    },
    {
      value: 'yon',
      label: '永贡语'
    },
    {
      value: 'xal',
      label: '卡尔梅克卫拉特语'
    },
    {
      value: 'iou',
      label: '图马伊鲁穆语'
    },
    {
      value: 'ssd',
      label: '西罗伊语'
    },
    {
      value: 'onb',
      label: '临高语'
    },
    {
      value: 'wsk',
      label: '瓦吉语'
    },
    {
      value: 'hlb',
      label: '亥比语'
    },
    {
      value: 'ntm',
      label: '纳特尼语'
    },
    {
      value: 'zyb',
      label: '邕北壮语'
    },
    {
      value: 'bch',
      label: '巴里亚语'
    },
    {
      value: 'bno',
      label: '班通安隆语'
    },
    {
      value: 'krs',
      label: '格巴亚语'
    },
    {
      value: 'kbo',
      label: '克利科语'
    },
    {
      value: 'tex',
      label: '腾内特语'
    },
    {
      value: 'bdu',
      label: '奥罗科语'
    },
    {
      value: 'bqj',
      label: '班迪亚勒语'
    },
    {
      value: 'lcm',
      label: '通加格语'
    },
    {
      value: 'bdh',
      label: '巴卡语'
    },
    {
      value: 'swp',
      label: '苏奥语'
    },
    {
      value: 'muv',
      label: '穆图凡语'
    },
    {
      value: 'ata',
      label: '佩勒-阿塔语'
    },
    {
      value: 'ssx',
      label: '桑贝里吉语'
    },
    {
      value: 'gnw',
      label: '西部玻利维亚瓜拉尼语'
    },
    {
      value: 'spy',
      label: '萨鲍特语'
    },
    {
      value: 'ptu',
      label: '邦邦语'
    },
    {
      value: 'cas',
      label: '齐马内语'
    },
    {
      value: 'wrs',
      label: '瓦里斯语'
    },
    {
      value: 'byr',
      label: '伊普马语'
    },
    {
      value: 'adh',
      label: '阿多拉语'
    },
    {
      value: 'any',
      label: '阿格尼桑维语'
    },
    {
      value: 'cpb',
      label: '阿舍宁卡语'
    },
    {
      value: 'teo',
      label: '特索语'
    },
    {
      value: 'bfa',
      label: '巴里语'
    },
    {
      value: 'ccp',
      label: '查克玛语'
    },
    {
      value: 'cbl',
      label: '布阿尔考钦语'
    },
    {
      value: 'cfm',
      label: '法兰钦语'
    },
    {
      value: 'cdf',
      label: '茨鲁语'
    },
    {
      value: 'gur',
      label: '法拉法拉语'
    },
    {
      value: 'gbo',
      label: '北部格雷博语'
    },
    {
      value: 'huv',
      label: '圣马特奥德马尔-瓦维语'
    },
    {
      value: 'keo',
      label: '卡库瓦语'
    },
    {
      value: 'cki',
      label: '喀克其奎语'
    },
    {
      value: 'pss',
      label: '卡乌龙语'
    },
    {
      value: 'kyu',
      label: '西部克耶语'
    },
    {
      value: 'jmc',
      label: '斯哈语'
    },
    {
      value: 'nyy',
      label: '尼亚库萨语'
    },
    {
      value: 'vun',
      label: '文约语'
    },
    {
      value: 'kle',
      label: '库隆语'
    },
    {
      value: 'guw',
      label: '龚语'
    },
    {
      value: 'gaa',
      label: '加语'
    },
    {
      value: 'efi',
      label: '埃菲克语'
    },
    {
      value: 'niu',
      label: '纽埃语'
    },
    {
      value: 'nzi',
      label: '恩泽马语'
    },
    {
      value: 'iso',
      label: '伊索科语'
    },
    {
      value: 'srm',
      label: '萨拉马坎语'
    },
    {
      value: 'bcl',
      label: '中比科尔语'
    },
    {
      value: 'hil',
      label: '希利盖农语'
    },
    {
      value: 'ada',
      label: '丹美语'
    },
    {
      value: 'tvl',
      label: '图瓦卢语'
    },
    {
      value: 'kik',
      label: '基库尤语'
    },
    {
      value: 'sxn',
      label: '桑格语'
    },
    {
      value: 'wls',
      label: '瓦利斯语'
    },
    {
      value: 'tll',
      label: '特特拉语'
    },
    {
      value: 'bas',
      label: '巴萨语'
    },
    {
      value: 'rar',
      label: '库克群岛毛利语'
    },
    {
      value: 'iba',
      label: '伊班语'
    },
    {
      value: 'ilo',
      label: '伊洛卡诺语'
    },
    {
      value: 'dua',
      label: '杜阿拉语'
    },
    {
      value: 'nia',
      label: '尼亚斯语'
    },
    {
      value: 'kbp',
      label: '卡比耶语'
    },
    {
      value: 'lus',
      label: '米佐语'
    },
    {
      value: 'urh',
      label: '乌尔霍博语'
    },
    {
      value: 'kam',
      label: '卡姆巴语'
    },
    {
      value: 'loz',
      label: '罗子语'
    },
    {
      value: 'pis',
      label: '皮京语'
    },
    {
      value: 'ibg',
      label: '伊巴纳格语'
    },
    {
      value: 'nba',
      label: '涅姆巴语'
    },
    {
      value: 'tsc',
      label: '茨瓦语'
    },
    {
      value: 'tdt',
      label: '帝力德顿语'
    },
    {
      value: 'tgl',
      label: '他加禄语'
    },
    {
      value: 'bum',
      label: '布卢语'
    },
    {
      value: 'dhv',
      label: '德鲁语'
    },
    {
      value: 'seh',
      label: '塞纳语'
    },
    {
      value: 'tiv',
      label: '蒂夫语'
    },
    {
      value: 'kwy',
      label: '圣萨尔瓦多刚果语'
    },
    {
      value: 'nij',
      label: '恩加朱语'
    },
    {
      value: 'pag',
      label: '邦阿西楠语'
    },
    {
      value: 'bci',
      label: '鲍勒语'
    },
    {
      value: 'ach',
      label: '阿乔利语'
    },
    {
      value: 'nyn',
      label: '恩科里语'
    },
    {
      value: 'lua',
      label: '卢巴开赛语'
    },
    {
      value: 'mfe',
      label: '毛里求斯克里奥尔语'
    },
    {
      value: 'lub',
      label: '卢巴-加丹加语'
    },
    {
      value: 'swc',
      label: '刚果斯瓦希里语'
    },
    {
      value: 'kmb',
      label: '金邦杜语'
    },
    {
      value: 'kqn',
      label: '卡昂多语'
    },
    {
      value: 'tzh',
      label: '泽塔尔语'
    },
    {
      value: 'lun',
      label: '隆打语'
    },
    {
      value: 'ish',
      label: '埃桑语'
    },
    {
      value: 'cjk',
      label: '乔奎语'
    },
    {
      value: 'umb',
      label: '姆班杜语'
    },
    {
      value: 'bhw',
      label: '比亚克语'
    },
    {
      value: 'gym',
      label: '圭米语'
    },
    {
      value: 'tum',
      label: '通布卡语'
    },
    {
      value: 'rnd',
      label: '卢乌德语'
    },
    {
      value: 'wes',
      label: '喀麦隆皮钦语'
    },
    {
      value: 'toj',
      label: '托霍拉瓦尔语'
    },
    {
      value: 'yap',
      label: '雅浦语'
    },
    {
      value: 'nyu',
      label: '尼荣圭语'
    },
    {
      value: 'cce',
      label: '乔皮语'
    },
    {
      value: 'chk',
      label: '丘克语'
    },
    {
      value: 'nav',
      label: '纳瓦霍语'
    },
    {
      value: 'cab',
      label: '加利富纳语'
    },
    {
      value: 'kea',
      label: '佛得角克里奥尔语'
    },
    {
      value: 'btx',
      label: '巴塔克卡罗语'
    },
    {
      value: 'ndc',
      label: '恩道语'
    },
    {
      value: 'sop',
      label: '松格语'
    },
    {
      value: 'ndo',
      label: '恩敦加语'
    },
    {
      value: 'mau',
      label: '瓦乌特拉马萨特克语'
    },
    {
      value: 'guc',
      label: '瓦尤语'
    },
    {
      value: 'bin',
      label: '埃多语'
    },
    {
      value: 'nyk',
      label: '尼亚内卡语'
    },
    {
      value: 'tzo',
      label: '索西语'
    },
    {
      value: 'pon',
      label: '波纳佩语'
    },
    {
      value: 'arn',
      label: '马普切语'
    },
    {
      value: 'ttj',
      label: '土柔语'
    },
    {
      value: 'lue',
      label: '卢瓦来语'
    },
    {
      value: 'pcm',
      label: '尼日利亚皮钦语'
    },
    {
      value: 'bzj',
      label: '伯利兹克里奥尔语'
    },
    {
      value: 'gug',
      label: '巴拉圭瓜拉尼语'
    },
    {
      value: 'her',
      label: '赫雷罗语'
    },
    {
      value: 'zne',
      label: '赞德语'
    }
  ];

  static transStatusArr = new Map([
    [103, '翻译中'],
    [104, '翻译终止'],
    [105, '翻译成功'],
    [106, '翻译失败']
  ])

  /**
   * 根据语种value获取语种的label标签
   * @param {string} value 语种的value值
   * @returns 语种的中文label
   */
  static getLang2Label (value) {
    const temp = this.langCodeArr.find((item) => item.value == value)
    return temp.label
  }

  /**
   * 将字符串经过md5加密
   * @param {string} params 需要加密的字符串
   * @returns 解密后的字符串
   */
  static str2md5 (params) {
    return md5(params)
  }

  /**
   *
   * @param {Array} shortArr 需要经过ASCII码排序的字符串数组
   * @returns 排序完成后的数组
   */
  static short2ASCII (shortArr) {
    return shortArr.sort()
  }

  /**
   * 将传入的参数obj对象格式化为authStr(权限字符串)
   * @param {Object} paramsObj 需要进行格式化的参数对象
   * @returns 格式化后的权限字符串
   */
  static formatParams (paramsObj) {
    const tempArr = []
    for (const key in paramsObj) {
      tempArr.push(key)
    }

    const sortArr = this.short2ASCII(tempArr)

    let paramsStr = ''
    sortArr.forEach((item, index) => {
      if (index == sortArr.length - 1) {
        paramsStr += item + '=' + paramsObj[item]
      } else {
        paramsStr += item + '=' + paramsObj[item] + '&'
      }
    })

    return this.str2md5(paramsStr)
  }
}
